import { useCallback, useState } from 'react'
import { useRouter } from 'next/router'
import { useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { apiFetch, errorMessage } from '@/lib/api-client'

export const useSignOut = () => {
    const router = useRouter()
    const queryClient = useQueryClient()
    const [pending, setPending] = useState(false)

    const signOut = useCallback(async () => {
        setPending(true)

        try {
            await apiFetch('/api/auth/logout', { method: 'POST' })
            queryClient.clear()
            await router.push('/')
            toast.success('You are signed out.')
        }
        catch (error) {
            toast.error(errorMessage(error))
        }
        finally {
            setPending(false)
        }
    }, [queryClient, router])

    return { signOut, pending }
}
